import { z } from 'zod';

export const SAGE_NOMINAL_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9./-]{0,19}$/;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const isRealDateBetween2000And2099 = (value: string): boolean => {
    const match = ISO_DATE.exec(value);
    if (!match) return false;
    const [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])];
    if (year < 2000 || year > 2099) return false;
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};

export const sageNominalSchema = z.object({
    nominalCode: z
        .string()
        .trim()
        .min(1, 'Enter an account code.')
        .max(20, 'Use at most 20 characters.')
        .regex(SAGE_NOMINAL_CODE_PATTERN, 'Use letters, digits, "-", "." or "/", starting with a letter or digit.'),
    nominalName: z
        .string()
        .trim()
        .max(100, 'Use at most 100 characters.')
        .transform((value) => (value === '' ? null : value)),
    effectiveFrom: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Enter a date.')
        .refine(isRealDateBetween2000And2099, 'Enter a date between 2000 and 2099.'),
});

export type SageNominalInput = z.input<typeof sageNominalSchema>;
